import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { VisibilityPicker } from "@/components/groups/VisibilityPicker";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const field = "w-full rounded-xl bg-[#1E1E1E] border border-[#27272A] px-3.5 py-2.5 text-sm text-[#F3F4F6] placeholder:text-[#6B7280] focus:outline-none focus:border-[#3B82F6]";

export const CreateGroupDialog = ({ open, onOpenChange, onCreated }) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [visibility, setVisibility] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) { setName(""); setDescription(""); setVisibility(null); } }, [open]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/groups", { name: name.trim(), description: description.trim(), visibility });
      toast.success(`Group "${r.data.name}" created`);
      onOpenChange(false);
      onCreated(r.data);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Couldn't create the group");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="group-create-dialog" className="bg-[#121212] border-[#27272A] text-[#F3F4F6] max-w-md pointer-events-auto">
        <DialogHeader>
          <DialogTitle className="font-heading">New group</DialogTitle>
          <DialogDescription className="text-[#9CA3AF]">You'll be the admin and approve everyone who asks to join.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <input data-testid="group-name-input" value={name} onChange={(e) => setName(e.target.value)} maxLength={60} placeholder="Group name" className={field} autoFocus />
          <textarea data-testid="group-description-input" value={description} onChange={(e) => setDescription(e.target.value)} maxLength={400} rows={3}
            placeholder="What's this group about? (optional)" className={`${field} resize-none`} />
          <div className="text-xs text-[#9CA3AF]">Who can find this group?</div>
          <VisibilityPicker value={visibility} onChange={setVisibility} />
          <button type="submit" disabled={busy || name.trim().length < 2 || !visibility} data-testid="group-create-submit-btn"
            className="w-full h-11 rounded-full bg-[#2563EB] hover:bg-[#1D4ED8] text-sm font-medium text-white flex items-center justify-center disabled:opacity-40">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Create group"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
